/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Linkcontent1Inputs */

const zh_course_linkcontent1 = /** @type {(inputs: Course_Linkcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关联内容`)
};

const en_course_linkcontent1 = /** @type {(inputs: Course_Linkcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Content`)
};

const es_course_linkcontent1 = /** @type {(inputs: Course_Linkcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vincular contenido`)
};

/**
* | output |
* | --- |
* | "Link Content" |
*
* @param {Course_Linkcontent1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_linkcontent1 = /** @type {((inputs?: Course_Linkcontent1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Linkcontent1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_linkcontent1(inputs)
	if (locale === "en") return en_course_linkcontent1(inputs)
	return es_course_linkcontent1(inputs)
});
export { course_linkcontent1 as "course_linkContent" }